<template>
    <li :class="{active:tab.active}">
        <a href="javascript:void(0)" :class="{disabled: !tab.checked}">
            <div class="wizard-icon-circle align-items-center md"
                 role="tab"
                 :tabindex="tab.checked ? 0 : ''"
                 :id="`step-${tab.tabId}`"
                 :aria-controls="tab.tabId"
                 :aria-disabled="tab.active"
                 :aria-selected="tab.active"
                 :class="{checked: tab.checked,square_shape:isStepSquare, tab_shape:isTabShape}"
                 :style="[tab.checked ? stepCheckedStyle : {}, tab.active ? iconActiveStyle: {}, tab.validationError ? errorStyle : {}]">

                <transition :name="transition" mode="out-in">
                    <div v-if="tab.active" class="wizard-icon-container align-items-center"
                         :class="{square_shape:isStepSquare, tab_shape:isTabShape}"
                         :style="[tab.validationError ? errorStyle : {}]">
                        <slot name="active-step">
                            <component width="1em" height="1em" :is="tab.icon"></component>
                        </slot>
                    </div>
                    <slot v-if="!tab.active">
                        <component width="1em" height="1em" v-if="!tab.active && tab.icon" class="wizard-icon"
                                   :is="tab.icon"></component>
                        <i v-if="!tab.active && !tab.icon" class="wizard-icon">{{index + 1}}</i>
                    </slot>
                </transition>
            </div>

            <slot name="title">
                <span class="stepTitle"
                      :class="{active:tab.active, has_error:tab.validationError}"
                      :style="tab.active ? stepTitleStyle : {}">
                      {{tab.title}}
                </span>
            </slot>
        </a>
    </li>
</template>

<script>
    import IInfo from "../Icons/IInfo";
    import IPersonFilled from "../Icons/IPersonFilled";
    import IAlarm from "../Icons/IAlarm";

    export default {
        name: "CustomWizardStep",
        components: {IInfo, IPersonFilled, IAlarm},
        props: {
            tab: {
                type: Object,
                default: () => {

                }
            },
            transition: {
                type: String,
                default: ''
            },
            index: {
                type: Number,
                default: 0
            }
        },
        computed: {
            iconActiveStyle() {
                return {
                    backgroundColor: this.tab.color
                }
            },
            stepCheckedStyle() {
                return {
                    borderColor: this.tab.color,
                    borderWidth: '1px'
                }
            },
            errorStyle() {
                return {
                    borderColor: this.tab.errorColor,
                    backgroundColor: this.tab.errorColor
                }
            },
            stepTitleStyle() {
                let isError = this.tab.validationError
                return {
                    color: isError ? this.tab.errorColor : this.tab.color
                }
            },
            isStepSquare() {
                return this.tab.shape === 'square'
            },
            isTabShape() {
                return this.tab.shape === 'tab'
            }
        }
    }
</script>

<style scoped>
    .wizard-icon-circle {
        border-color: #CEDBFF;
        background: #CEDBFF;
        height: 30px !important;
        width: 30px !important;
    }

    li {
        flex: 0 !important;
        -webkit-box-flex: 0 !important;
    }
</style>
